var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NotificationItem",class:("NotificationItem--type-" + (_vm.notification.type)),on:{"click":_vm.remove}},[_c('div',{staticClass:"NotificationItem__message"},[_vm._v(" "+_vm._s(_vm.notification.message)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }